import jobs from './jobs';
import settings from './settings';
import dashboard from './dashboard';
import projects from './projects';
import pGroups from './project-groups';
import reports from './reports';
import documentation from './documentation';
import overview from './overview';
import auth from './auth';
import general from './general';
export default [
  ...auth,
  ...projects,
  ...pGroups,
  ...reports,
  ...overview,
  ...documentation,
  ...jobs,
  ...dashboard,
  ...settings,
  ...general,
];
